import { AUTHORITIES } from "@/config/constants";
import { useAppSelector } from "@/config/store";
import { hasAnyAuthority } from "@/shared/auth/private-route";
import { AuthenticationState } from "@/shared/reducers/authentication";
import { EdoStudentState } from "@/shared/reducers/entities/edo-student.reducer";
import { EdoTeacherState } from "@/shared/reducers/entities/edo-teacher.reducer";
import { Card, Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui";
import { useMemo, useState } from "react";
import { Translate } from "react-jhipster";
import CoursesGroup from "./components/CoursesGroup";
import { School } from "lucide-react";

const Classes = () => {
  const [tab, setTab] = useState<string>("0");
  const { account } = useAppSelector<AuthenticationState>(
    (state) => state.authentication
  );
  const { classes: teacherClasses } = useAppSelector<EdoTeacherState>(
    (state) => state.edoTeacher
  );
  const { classes: studentClasses } = useAppSelector<EdoStudentState>(
    (state) => state.edoStudent
  );

  const classes = useMemo(() => {
    if (hasAnyAuthority(account?.roles || [], [AUTHORITIES.ROLE_TEACHER])) {
      return teacherClasses ?? [];
    }
    if (hasAnyAuthority(account?.roles || [], [AUTHORITIES.ROLE_STUDENT])) {
      return studentClasses ?? [];
    }
    return [];
  }, [account?.roles, teacherClasses, studentClasses]);

  return (
    <Card className="overflow-hidden rounded-3xl border border-[var(--color-mockup-border)] shadow-card bg-surface p-0">
      <div className="border-b border-[var(--color-mockup-border)] px-5 py-4 bg-[var(--color-surface-secondary)]/30">
        <h2 className="font-heading text-lg font-bold text-[var(--color-mockup-text)]">
          <Translate contentKey="edocendoApp.edoClass.home.title" />
        </h2>
      </div>
      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <div className="flex flex-wrap items-center gap-2 border-b border-[var(--color-mockup-border)] px-4 py-3">
          <TabsList className="h-auto w-full flex-wrap justify-start gap-2 border-0 bg-transparent p-0">
            {classes.length > 0 &&
              classes.map((edoClass, index) => (
                <TabsTrigger
                  key={edoClass.id}
                  value={String(index)}
                  className="rounded-full border border-[var(--color-mockup-border)] bg-surface px-4 py-1.5 text-xs font-bold shadow-sm data-[state=active]:border-transparent data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:shadow-md"
                >
                  {edoClass.year?.year}°{edoClass.section} ({edoClass.school?.code})
                </TabsTrigger>
              ))}
          </TabsList>
        </div>
        {classes.length > 0 ? (
          classes.map((edoClass, index) => (
            <TabsContent
              key={edoClass.id}
              value={String(index)}
              className="mt-0 focus-visible:ring-0 focus-visible:outline-none"
            >
              <CoursesGroup class={edoClass} />
            </TabsContent>
          ))
        ) : (
          <div className="px-6 py-12 text-center">
            <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
              <School className="h-5 w-5 text-primary" />
            </div>
            <p className="text-sm font-medium text-[var(--color-mockup-text-mid)]">
              <Translate contentKey="edocendoApp.edoCourse.home.notFound" />
            </p>
          </div>
        )}
      </Tabs>
    </Card>
  );
};

export default Classes;
